/**
 * The backend serves raw files with `Content-Type: application/octet-stream`,
 * so `res.blob()` yields a blob typed as octet-stream. An `<iframe>` pointed at
 * an object URL of an octet-stream blob cannot render inline and the browser
 * downloads it instead. Re-wrap the blob with the correct MIME type so the
 * browser's built-in PDF viewer renders it in the iframe.
 */
export const withPdfMimeType = (blob: Blob): Blob =>
  blob.type === "application/pdf"
    ? blob
    : new Blob([blob], { type: "application/pdf" })
